import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { googleIntegrationsService as google } from '../../services/api';

export default function GoogleTaskMonitoring({ connected, onRefresh }) {
  const [saved, setSaved] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function load() {
    try { const value = await google.taskMonitoring(); setSaved(value); setEnabled(value.enabled); setError(''); }
    catch { setError('Task monitoring settings could not be loaded.'); }
  }
  useEffect(() => { load(); }, [connected]);
  async function save(event) {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const value = await google.saveTaskMonitoring({enabled, expected_revision:saved.revision});
      setSaved(value); setEnabled(value.enabled);
    } catch (failure) { setError(typeof failure.response?.data?.detail === 'string' ? failure.response.data.detail : 'Could not save. Reload the settings before trying again.'); }
    finally { setBusy(false); }
  }
  async function refresh() {
    setBusy(true); setError('');
    try { await google.syncNotes(); await onRefresh(); }
    catch (failure) { setError(typeof failure.response?.data?.detail === 'string' ? failure.response.data.detail : 'Refresh could not start. Check the latest sync result.'); }
    finally { setBusy(false); }
  }
  return <section className="surface-panel mb-5 space-y-3 p-5" aria-label="Google Task monitoring">
    <h2 className="font-bold">Google Task reminders</h2>
    <p className="text-sm text-[#68746d]">Imported tasks appear in Assistant and Today with their confirmed status and scheduled day. Completion resolves that task’s reminders; separate note reminders and commitments stay intact.</p>
    {saved && <>
      <p className="text-sm" role="status">{saved.enabled ? 'Periodic refresh enabled' : 'Periodic refresh off'} · {saved.message}</p>
      <form onSubmit={save} className="space-y-3">
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={enabled} disabled={busy || (!connected && !enabled)} onChange={event => setEnabled(event.target.checked)} />Refresh Google Tasks automatically</label>
        <p className="text-xs text-[#68746d]">Reads your Google Tasks about every 15 minutes when background monitoring and the worker are running. It imports new tasks and their notes. It does not export notes or apply proposed changes. After an hour without a confirmed read, task reminders pause and a refresh notice appears. Free hosting can sleep.</p>
        <div className="flex flex-wrap gap-2"><button className="secondary-button text-xs" disabled={busy}>Save task monitoring</button><button type="button" className="quiet-button text-xs" disabled={busy} onClick={load}>Reload monitoring settings</button>
          <button type="button" className="secondary-button text-xs" disabled={busy || !connected} onClick={refresh}>Refresh Google Tasks now</button>
          <Link className="quiet-button text-xs" to="/assistant?view=settings">Background monitoring settings</Link></div>
      </form>
      {saved.last_attempt_at && <p className="text-xs">Last periodic attempt: {new Date(saved.last_attempt_at).toLocaleString()} · {saved.last_status}</p>}
      {saved.last_success_at && <p className="text-xs">Last complete periodic refresh: {new Date(saved.last_success_at).toLocaleString()}</p>}
      {saved.last_error && <p className="text-xs text-[#996617]">{saved.last_error}</p>}
    </>}
    {error && <p role="alert" className="text-sm text-[#996617]">{error} {!saved && <button className="underline" onClick={load}>Reload monitoring settings</button>}</p>}
  </section>;
}
